// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dA","message":"dB","header":"dC","subHeading":"dD","buttons":"dE","buttonWrapper":"dF","btn":"dG"};